var ACC = {
  config: {
	contextPath: document.getElementById('ph-content_path').value,
	commonResourcePath: document.getElementById('ph-commonresource_path').value,
	themeResourcePath: document.getElementById('ph-themeresource_path').value,
	siteResourcePath: document.getElementById('ph-siteresource_path').value,
	rootPath: document.getElementById('ph-siteroot_url').value,
	addToCart: document.getElementById('ph-addtocarttextvar').value,
	encodedContextPath: document.getElementById('ph-encodedcontent_path').value,
  },
 autocompleteUrl : document.getElementById('ph-autocomplete_url').value
};